import _get from 'lodash/get';

export enum AiContentBlockType {
  Text = 'text',
  EntityRef = 'entity_ref',
}

export type AiTextBlock = {
  type: AiContentBlockType.Text;
  text: string;
};

export type AiEntityRefBlock = {
  type: AiContentBlockType.EntityRef;
  // Currently only 'DocumentationVersion' is supported by the BE.
  entityType: string;
  id: string;
  label?: string;
};

export type AiContentBlock = AiTextBlock | AiEntityRefBlock;

// Read a field only when it is actually a string. contentBlocks is untyped BE
// JSON; a non-string (e.g. a localised `{en: '…'}` label) would otherwise flow
// through the `as string` casts into React children and throw "Objects are not
// valid as a React child", taking down the whole conversation pane.
function getString(block: unknown, path: string): string | undefined {
  const value = _get(block, path);
  return typeof value === 'string' ? value : undefined;
}

// contentBlocks is an untyped CamelizedJson payload; parse defensively and
// degrade unknown block types to text (via their label/text) instead of
// dropping content.
export default function parseContentBlocks(
  contentBlocks: unknown,
): AiContentBlock[] {
  if (!Array.isArray(contentBlocks)) return [];
  const result: AiContentBlock[] = [];
  contentBlocks.forEach((block) => {
    const type = getString(block, 'type');
    if (type === AiContentBlockType.EntityRef) {
      const id = getString(block, 'id');
      const entityType = getString(block, 'entityType');
      if (!id || !entityType) return;
      result.push({
        type: AiContentBlockType.EntityRef,
        entityType,
        id,
        label: getString(block, 'label') || undefined,
      });
      return;
    }
    const text = getString(block, 'text') || getString(block, 'label');
    if (text) {
      result.push({ type: AiContentBlockType.Text, text });
    }
  });
  return result;
}
